import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import React from 'react';

interface EllipsisTooltipProps {
	items: any[];
	maxVisibleItems: number;
	dataTestId?: string;
}

export const generateEllipsisTooltip = ({
	items,
	maxVisibleItems,
	dataTestId,
}: EllipsisTooltipProps) => {
	const visibleItems = items.slice(0, maxVisibleItems);
	const extraCount = items.length - maxVisibleItems;

	return (
		<Typography>
			{visibleItems && (
				<div>
					<span>{visibleItems.map((item) => item.name).join(',')}</span>

					{extraCount > 0 && (
						<Tooltip
							title={
								<ul>
									{items.map((item) => (
										<li key={item.id}>{item.name}</li>
									))}
								</ul>
							}
							arrow
							placement="right"
						>
							<span
								role="presentation"
								data-testid={dataTestId}
							>{`..+${extraCount}`}</span>
						</Tooltip>
					)}
				</div>
			)}
		</Typography>
	);
};
